<div class="side-bar" [ngClass]="[enableSidebar ? 'side-bar--mobile':'side-bar' ]">
    <div class="side-bar__logo">
        <img src="assets/images/logo/logo.png"/>FractionVault 
        <div class="close-icon" (click)="closeSideBar()">X</div>
    </div>
    <div class="side-bar__container">
        <ng-container *ngFor="let submenu of menu">
            <div class="side-bar__container__heading"  *ngIf="submenu.role[0].includes(currentUser.role)" >
                {{submenu.title}}
            </div> 
            <ng-container  *ngFor="let item of submenu.children">
                <div class="side-bar__container__item" *ngIf="item.role.includes(currentUser.role)"  [ngClass]="[item.title === selectedItem ? 'side-bar__container__item--selected':'side-bar__container__item']">
                    <div class="side-bar__container__item--container" *ngIf ="showOrHideArrow(item)" (click)="showSubMenu(item)">
                        <span>{{item.title}}</span>
                        <span class="side-bar__container__item--arrow" [ngClass]="[item.title === selectedItem ? 'side-bar__container__item--arrow--selected':'side-bar__container__item--arrow']" ></span>
                    </div>
                    <div class="side-bar__container__item--container" *ngIf ="!showOrHideArrow(item)" (click)="selectItem(item)">
                        <span>{{item.title}}</span>
                    </div>
                    <ng-container *ngIf="item.title == selectedItem && openSpecificMenu">
                        <div class="side-bar__container__item--specific">
                            <ng-container  *ngFor="let specificitem of item.children">
                                <div  class="side-bar__container__item--specific--menu"  [ngClass]="[specificitem.title === selectedSpecificItem ? 'side-bar__container__item--specific--menu--selected':'side-bar__container__item--specific--menu']" (click)="selectSpecificItem(specificitem)">
                                        <ng-container *ngIf="specificitem.title === selectedSpecificItem">
                                            <div class="image"><img src="../../../../assets/images/pages/radio-selected.png" /></div>
                                        </ng-container>
                                        <ng-container *ngIf="specificitem.title !== selectedSpecificItem">
                                            <div class="image"><img src="../../../../assets/images/pages/radio-unselected.png" /></div>
                                        </ng-container>
                                        {{specificitem.title}}
                                    <div class="side-bar__container__item--specific--menu--line"></div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div> 
            </ng-container>
        </ng-container>
    </div>
</div>